import { useEffect, useState } from "react";
import InvestigationDetails from "./InvestigationDetails";
import "../Page/claimProcessing.scss"
import { getInvestigationTable } from "./investigationHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { INVESTIGATION_TYPES, PAGE_NAME_KEYS } from "../../../../consts";
import { toast } from "react-toastify";
import { searchClaimProcessing } from "../Service/apiHelper";

const InvestigationPage = (props) => {
  const { claimDetails, roleDataCookie, activeTab} = props;
  const [investigationLists, setInvestigationLists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notified, setNotified] = useState(false);
  // const [showCloseModal, setShowCloseModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getInvestigationLists = async () => {
    setLoading(true);
    try {
      // API call to fetch medical review data      
      const response = await getInvestigationTable(claimDetails?.claimId, INVESTIGATION_TYPES.GENERAL);
      if ( response?.data) {
        setInvestigationLists( response?.data);  
      } else {
        setInvestigationLists([]);
      }
    } catch (error) {
      console.error("Failed to fetch medical review list:", error);
      setInvestigationLists([]);
    } finally {
      setLoading(false);
    }
  }

  const handleClaimChange = (claimId) => {
      setLoading(true)
      searchClaimProcessing(
        { claimId },
        { size: 10, page: 0 },
        (list) => {
          if (list.length) {
            navigate(
              `/dashboard/${PAGE_NAME_KEYS.HEALTH_CLAIM_PROCESSING}/${PAGE_NAME_KEYS.CLAIM_DETAILS}`, {
              state: {
               ...location.state,
                claimDetails: list[0]
              }
            }
            );
          } else {
            toast.error("Something Went Wrong.")
          }
        }
      );
      setLoading(false) 
  }

  useEffect(() => {
    if (claimDetails?.claimId && activeTab === "INVESTIGATION") {
      getInvestigationLists();
    }
  }, [claimDetails?.claimId, activeTab]);

  useEffect(() => {
    if (notified === true) {
      getInvestigationLists();
      setNotified(false);
      handleClaimChange(claimDetails?.claimId);
    }
  }, [notified]);

  return (
    <div className="claim-processing-tabs bg-white">
      <InvestigationDetails
        investigationLists={investigationLists}
        loading={loading}
        claimDetails={claimDetails}
        roleDataCookie={roleDataCookie}
        setNotified={setNotified}
        handleOpenInvestigationReviewModal={() => {}}
        activeTab={activeTab} 
      />

      {/* {showCloseModal && (
        <InvestigationRequest
          mode="close"
          onClose={handleCloseModal}
          claimDetails={claimDetails}
          setNotified={setNotified}

        />
      )} */}
    </div>
  );
};

export default InvestigationPage;